
<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="d-flex align-items-center my-1">
                <div class="mx-2 h3">FAQs</div>
                <router-link to="/faqs/add" v-if="permissions.ADD_CONTENT == 'Y'">
                    <button class="btn btn-sm border border-primary text-primary">
                        Add New FAQ
                    </button>
                </router-link>
            </div>
            <AllElements category_id="6" editLink="faqs"></AllElements>
        </div>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    setup() { },
    created() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    components: {
        AllElements,
    },
    data() {
        return {
            permissions: {},
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'FAQs',
                    to: '/faqs/all'
                }, {
                    text: 'All FAQs',
                    href: '#'
                }
            ],
        }
    }
};
</script>